import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 16 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 4\" id=\"icon-more\"><circle cx=\"2\" cy=\"2\" r=\"2\" fill=\"#686766\" transform=\"rotate(-90 2 2)\" /><circle cx=\"8\" cy=\"2\" r=\"2\" fill=\"#686766\" transform=\"rotate(-90 8 2)\" /><circle cx=\"14\" cy=\"2\" r=\"2\" fill=\"#686766\" transform=\"rotate(-90 14 2)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol